(() => {
  const SELECTORS = {
    root: ".alert",
    close: ".alert__close",
    item: ".alert__item",
  };

  const observer = new MutationObserver(() => {
    const alert = document.querySelector(SELECTORS.root);

    if (alert) {
      Array.from(alert.querySelectorAll(SELECTORS.close)).forEach((button) => {
        button.addEventListener("click", ({ target }) =>
          onClose(alert, target.closest(SELECTORS.item), SELECTORS.item),
        );
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });

  /**
   * @param {HTMLElement} alert
   * @param {HTMLElement} item
   * @param {string} selector
   */
  function onClose(alert, item, selector) {
    if (!item) return;

    item.remove();

    // When all alerts have been closed,
    // we can remove the wrapper.
    if (alert.querySelectorAll(selector).length === 0) {
      alert.remove();
    }
  }
})();
